exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".subscribed-1{fill:none}.subscribed-2{fill:#caebe8}.subscribed-3{fill:#1e4e69}\n", ""]);
